export default __webpack_public_path__ + "static/media/okt-banner-tv.edfb7a47.png";